import { getDocument } from 'pdfjs-dist/build/pdf';

export class PdfService {
  static async getPageOneData(rawData: string) {
    const pdfBase64: string = rawData.substr(rawData.indexOf(',') + 1);
    const doc = await getDocument({ data: atob(pdfBase64) });
    return doc.getPage(1);
  }

  static async renderPdfImage(data: string, canvas: HTMLCanvasElement, scale: number): Promise<string> {
    const page1 = await PdfService.getPageOneData(data);
    if (canvas) {
      const viewport = page1.getViewport(scale);
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      const ctx = canvas.getContext('2d');

      const task = page1.render({
        canvasContext: ctx,
        viewport: viewport,
      });
      await task.promise;

      const imageData = canvas.toDataURL();
      return imageData;
    }
  }
}
